import { FC } from 'react';

import { Invoice } from '@ravago/shared/page-data/models/elements';
import { PaginatedResponse } from '@ravago/shared/page-data/models/elements/paginated-response.model';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableHead } from '@ravago/shared/radiance/components/table/components/TableHead/TableHead';
import { TableHeader } from '@ravago/shared/radiance/components/table/components/TableHeader/TableHeader';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { ClosedInvoiceTableRow } from './closed-invoice-table-row';

type Props = {
   invoices: { [page: number]: PaginatedResponse<Invoice[]> };
   page: number;
};

export const ClosedInvoiceTableDesktop: FC<Props> = ({ invoices, page }) => {
   const translate = useTranslations();

   return (
      <Table>
         <TableHead>
            <TableRow>
               <TableHeader>
                  <Typography variant="small-highlight">{translate('invoices.closed-invoices.table.table-header.invoice')}</Typography>
               </TableHeader>
               <TableHeader>
                  <Typography variant="small-highlight">{translate('invoices.closed-invoices.table.table-header.date')}</Typography>
               </TableHeader>
               <TableHeader>
                  <Typography variant="small-highlight">{translate('invoices.closed-invoices.table.table-header.legal-entity')}</Typography>
               </TableHeader>
               <TableHeader>
                  <Typography variant="small-highlight">{translate('invoices.closed-invoices.table.table-header.paid-amount')}</Typography>
               </TableHeader>
               <TableHeader>{/* Placeholder */}</TableHeader>
               <TableHeader>{/* Placeholder */}</TableHeader>
            </TableRow>
         </TableHead>
         <TableBody>
            {invoices[page].content.map((invoice) => (
               <ClosedInvoiceTableRow key={invoice.id} invoice={invoice} />
            ))}
         </TableBody>
      </Table>
   );
};
